module.exports = __webpack_public_path__ + "assets/icon-conductor-ironWirePermanent.528cec01.svg";